export default "__VITE_ASSET__wfFODBP7__"